/*
parameters:
error object | Type : Object
*/

export function apiErrorrHandler(error) {
  if (!error.response) {
    return error?.message || "Network error, please check your connection"
  }

  const status = error.response?.status
  const serverMessage = error.response?.data?.message

  if (status === 500) {
    return "Something Went Wrong Please Try Again Later"
  } else if (status === 404) {
    return "Sorry, the resource is not found"
  } else {
    return serverMessage || error?.message || error?.toString()
  }
}
